import styled, { css } from 'styled-components';
import { Image } from '../Image/Image.es.js';
import 'react';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import { palette, spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { Text } from '../Text/Text.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
var PeopleCard = styled.div.withConfig({
  componentId: "sc-1rnlhwb-0"
})(["display:flex;flex-direction:column;align-items:center;cursor:pointer;overflow:hidden;"]);
var PeopleCardImageWrapper = styled(Box).withConfig({
  componentId: "sc-1rnlhwb-1"
})(["width:220px;max-width:100%;position:relative;overflow:hidden;border-radius:50%;background-color:", ";margin-bottom:", ";color:", ";&::before{content:' ';display:block;padding-bottom:100%;}"], palette("neutral.800"), spacing("sm"), palette("neutral.500"));
var position = css(["position:absolute;top:0;left:0;width:100%;height:100%;"]);
var PeopleCardImage = styled(Image).withConfig({
  componentId: "sc-1rnlhwb-2"
})(["", " object-fit:cover;"], position);
var FallbackWrapper = styled.div.withConfig({
  componentId: "sc-1rnlhwb-3"
})(["", " display:flex;align-items:center;justify-content:center;"], position);
var PeopleCardTitle = styled(Text).withConfig({
  componentId: "sc-1rnlhwb-4"
})(["color:", ";"], palette("neutral.50"));
var PeopleCardDescription = styled(Text).withConfig({
  componentId: "sc-1rnlhwb-5"
})(["color:", ";"], palette("neutral.400"));
export { FallbackWrapper, PeopleCard, PeopleCardDescription, PeopleCardImage, PeopleCardImageWrapper, PeopleCardTitle };